import Analytics from './analytics.js';

const init = (container) => {

    
    const bannerClick = datalayerPush('eventBannerClick');
    const categoryBannerClick = datalayerPush('eventCategoryBannerClick');
    const editorialEventClick = datalayerPush('BannerClick');
    const bookingEvent = datalayerPush('eventfilter');

    //TODO: implement after booking is complete
    const bookingEventComplete = datalayerPush('eventBookingComplete');

    const handleCardClick = (e) => {
        const target = e.currentTarget;
        const eventName = target.querySelector('.event-card__title')?.textContent;
        if (!eventName) return;

        const bannerElem = target.querySelector('.event-card__status');
        const bannerText = bannerElem ? [...bannerElem.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()?.length > 0).textContent?.trim() : "";
        bannerClick({eventName: eventName, eventBanner: bannerText});
    }
    
    const cards = [...container.querySelectorAll('.event-card:not(.event-list .event-card)')];
    cards.forEach(card => card.addEventListener('click', e => handleCardClick(e, card, bannerClick)));
    
    
    const containerForDynamicContent = container.querySelector('.event-list');
    if (containerForDynamicContent) {
        containerForDynamicContent.addEventListener('click', (e) => {
            const target = e.target.closest('.event-card');
            
            if (target) {
                handleCardClick(e, target, bannerClick);
            }
        })
    }
                
    
    const eventSubjectCards = [...container.querySelectorAll('.event-subjects__item')];
    eventSubjectCards.forEach(card => card.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const eventName = target.querySelector('.event-subjects-card__title')?.textContent;
        categoryBannerClick({bannerClickText: eventName});
    }));
    
    const editorialEventCards = [...container.querySelectorAll('.event-excerpt')];
    editorialEventCards.forEach(card => card.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const eventName = target.querySelector('.event-excerpt__heading')?.textContent;
        editorialEventClick({bannerClickText: eventName});
    }));
    
    const filterDropdowns = [...container.querySelectorAll('.EventFilter__dropdown')];

    addFilterDropdownEvents(filterDropdowns, bookingEvent);
};

function addFilterDropdownEvents(filterDropdowns, callback) {
    const dropdownMappings = {
        "location": "Plats",
        "subject": "Ämne",
        "targetAudiences": "Målgrupp",
        "category": "Typ",
        "branch": "Bransch",
    }
    
    filterDropdowns.forEach(dropdown => {
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
        const dropdownName = hiddenInput.name;
        const filterType = dropdownMappings[dropdownName];

        const dropdownItems = [...dropdown.querySelectorAll('.EventFilter__dropdown_item')];
        dropdownItems.forEach(item => {
            item.addEventListener('click', (e) => {
                const target = e.currentTarget;
                const itemText = target.textContent.trim();
                callback({filterType, filterValue: itemText});
            });
        });
    });
}
const datalayerPush = (name) => (data) => {
    Object.keys(data).forEach(key => {
        if(typeof data[key] === 'string') data[key] = data[key].trim();
    });
    const dataLayer = window.dataLayer || [];
    data = {...data, ...{selectedBranch: Analytics.getBranchName(), isAuthenticated: Analytics.getAuthenticated()}};
    dataLayer.push({
        event: name,
        ...data,
    });
}

document.addEventListener('DOMContentLoaded', () => {

    const bodyContainer = document.querySelector('.eventlistpage');
    if(bodyContainer) {
        init(bodyContainer);
    }
    
    const eventPageContainer = document.querySelector('.eventpage');
    
    if(eventPageContainer) {
        const banner = eventPageContainer.querySelector('.event-page__card-cta');
        
        if (!banner) return;
        
        const button = banner.querySelector('a.button-new[href]');

        const bookingEvent = datalayerPush('eventBooking');
        if (button) {
            button.addEventListener('click', () => {
                bookingEvent({eventName: eventPageContainer.querySelector('.event-page__title').textContent});
            });
        }
    }
});
